<div class="notification-failed">
<div class="event-item">
    <span class="notification-activity dismiss" (click)="dismiss()">Dismiss</span>
    <div class="header-notification">
      <h3>{{notification.data.details.title}}</h3> <strong>FAILED</strong>
    </div>
    <p [innerHTML]="notification.data.details.message">{{notification.data.details.message}}</p>
</div>
</div>